"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// eslint-disable-next-line
var imgBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAt1BMVEUAAADV9f/T3+3T3+3U4u/U4fDT3u3T3u3S3+zT4O/U4e/U4e7Z5v/U4O3T3+zS3+3T3+zS3+zS3+zS3+3T3+3T3+3T3uzS3+zT3u3T4O7S3+zT3+7T3+3S3u3V4O/X5PLY4vXX5PLe7O9QofxRov9Qof3T3uxRov9PofxPofxPoPzT3+xRov1Tpv9QoPxQoPxPoPtPoftQo/xQofxQoPxQofySwPVRofxRovxTp//S3uxPoPyQv/N27P78AAAAOnRSTlMABO9yNCH50rBcQzsKY+ff3NjMyLm4sqWckomEf1UxJhoTD7Q1cW0j69yEbkEP8O/QyFylnJJlYlUdiMhMxQAAAllJREFUWMOt2Od26jAMAGA5O+xV9h6l0NJ1t+j7P9c9HuCEUpoo+v4knJwIW/GGW9Z/9qvX3cMxcOphNKx6Agj+bVYvRwMNJ7qfQy7ifXVMwIROXIGsDpuHYwqm1NxsoYQNYwOlOW6GbD292gDPq/37ensQYuF78ajr2FBh+bvi/DpH2e3X4uKhN27gyeBmobZvR+PHGq4q99Bo+Teq9WzC/NzCl/z+KVMl+MJfE+ZtDTdN26gEE7jqt4mzgW+5qFXhigl+yDAvT5BByXzByZVHAcpIuy1kMmvq2n3Kk6/+4mN1gIyWdzrjPqSIFkp3AjITOlIr/coApeYScljq2g1SzUwXcwa5zHTGy4lShiiVIKeS7nfiolm4kNflixVVxDYQtFVKKqm4UyCYJotUqckffSBRPbimixSj5AOJj1IMUkfe9oCop2YEeTc3jYHANkE5Sz3KmwaQqdH3HgAieTMGsrF8PwIQqhF5QOappiTOVyJbkqq8dKGArh50h/IyggJGMsJQ5zqGAmKd7dDkumC2Q6gn+we9l9RB5XwBBSzUd4dAXgQUINS8xBaIrWpsyWb7/GwNkq2LsHVatmGEbWDjGmrZBn+26YhrgmSbstkWEVzLGraFFtfSj20xyrU85lyw828hwHd0pCV9U2O3WVJzRtxmWRO7UyVt/Kwqai5xK2pNAlTaU/Lm2BZY6/uk7brlt9DolSkHCJYY4Elj7BGONKxyiGdOdxR7/oJwyCIJ18ELhGMfpeLWMIVyEGVCxR1MIByNWfPHyFaReFhnv1J1GIV1J8hyfPgfTsTbBh0TutYAAAAASUVORK5CYII=';
var animationCss = '@-webkit-keyframes goblin-loading-animation {100%{-webkit-transform: rotate(360deg);}}'; // eslint-disable-next-line

var domCss = 'position: fixed;left: 50%;top: 50%;width: auto;height: auto;-webkit-transform: translate(-50%,-50%);z-index: 9999;';
var domCssMask = 'left: 0;top: 0;width: 100%;height:100%;-webkit-transform: translate(0,0)';
var conCss = 'display:-webkit-box;-webkit-box-align:center;-webkit-box-pack: center;width: 100%;height:100%;'; // eslint-disable-next-line

var contentCss = 'min-width: 1.6rem;max-width:4.2rem;padding: 0.4rem;color: #fff;text-align:center;background-color: rgba(58, 58, 58, 0.9);border-radius: 0.13333rem;';
var imgConCss = 'display:inline-block;-webkit-animation: goblin-loading-animation 1s linear infinite;';
var imgCss = 'width:0.96rem;height:0.96rem;vertical-align: middle;';
var textCss = 'font-size:0.37rem;word-break: break-all;';
var textItemCss = 'margin-top: 0.2rem;';
var id = 'goblin-loading';
var textId = 'goblin-loading-text';
var dom = null;
var timer = null;
var count = 0;
var loading = {
  show: function show() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;
    var mask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var textHtml = text ? "<div style=\"".concat(textItemCss, "\">").concat(text, "</div>") : '';

    if (!dom) {
      var head = document.getElementsByTagName('HEAD')[0];
      var link = document.createElement('style');
      link.type = 'text/css';
      link.innerHTML = animationCss;
      head.appendChild(link);
      dom = document.createElement('div');
      dom.id = id; // dom.style = domCss;

      dom.setAttribute('style', domCss);
      document.body.appendChild(dom);
      dom.innerHTML = "<div style=\"".concat(conCss, "\"><div style=\"").concat(contentCss, "\">\n        <div style=\"").concat(imgConCss, "\"><img style=\"").concat(imgCss, "\" src=\"").concat(imgBase64, "\" /></div>\n        <div id=\"").concat(textId, "\" style=\"").concat(textCss, "\">").concat(textHtml, "</div>\n      </div></div>");
    } else {
      timer && clearTimeout(timer);
      document.getElementById(textId).innerHTML = textHtml;
      dom.style.display = 'block';
    }

    if (mask) {
      // dom.style = domCss + domCssMask;
      dom.setAttribute('style', domCss + domCssMask);
    } else {
      // dom.style = domCss;
      dom.setAttribute('style', domCss);
    }

    if (time > 0) {
      timer = setTimeout(function () {
        loading.hide();
      }, time);
    }

    count += 1;
  },
  hide: function hide() {
    var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (flag) {
      count = 0;
    }

    if (count > 0) {
      count -= 1;
    }

    if (dom && count === 0) {
      dom.style.display = 'none';
      timer && clearTimeout(timer);
    }
  }
};
var _default = loading;
exports.default = _default;